module.exports = __webpack_public_path__ + "static/media/security-concept-illustration.8b9c43b7.jpg";